// This file will content all global constant used across multiple pages.

export const RECAPTCHA_SITE_KEY = '6LfKUFkcAAAAAMwE_KaEBHVxVRw_klVZlOXtUhug';
